<template>
  <q-page padding>

    <!-- <h4 class="text-center text-primary q-my-lg">Step 1 of 2</h4> -->
    <div class="q-pa-md q-gutter-sm text-center">
      <q-avatar size="155px">
        <img v-if="getLine.pictureUrl == ''" src="../assets/profile.png" alt="">
        <img v-else :src="getLine.pictureUrl" alt="">
      </q-avatar>

      <p>{{ getLine.displayName }}</p>
    </div>

    <otp-form />
    <q-btn flat color="primary" icon="keyboard_arrow_left" label="แก้ไขข้อมูล" class="q-ma-lg full-width" @click="resetData" />

  </q-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      line_id: ''
    }
  },
  methods: {
    ...mapActions('auth', ['handleLogin']),
    resetData () {
      this.line_id = this.getLine.userId
      console.log(this.line_id)
      axios.delete(`${process.env.VUE_APP_API}api/line?line_id=${this.line_id}`)
        .then((res) => {
          this.$router.push('/register', () => {})
        })
        .catch(e => {
          if (e.response.status === 401) {
            // console.log(e.response.status)
            this.$router.push('/register', () => {})
          }
        })
    }
  },
  computed: {
    ...mapGetters('auth', ['getLine', 'getProfile'])
  },
  components: {
    'otp-form': require('../components/OtpForm.vue').default
  },
  mounted () {
    this.handleLogin()
  }

}
</script>

<style lang="scss" scoped>

</style>
